/* eslint-disable */

import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import env from '../../env/env'
import { useModal } from '../../hooks/use-modal-store'
import { Skeleton } from '../ui/skeleton'
import FullPagePopupLayout from './FullPagePopupLayout'

const ACTION_PLAN_POPUP_CLASS = 'fabits-action-plan-popup'

const ActionPlanLoadingState = () => (
  <div className='fabits-basket-popup-card'>
    <div className='flex items-center space-x-4'>
      <Skeleton className='h-12 w-12 rounded-lg' />
      <div className='space-y-2'>
        <Skeleton className='h-4 w-[200px]' />
        <Skeleton className='h-4 w-[100px]' />
      </div>
    </div>
    <Skeleton className='h-4 mt-2 w-[100px]' />
  </div>
)

const ActionPlanRows = ({
  basketDetails,
  expandedBaskets,
  toggleBasketExpansion,
  tone = 'success',
}) => {
  if (!basketDetails) return null

  return (
    <div className='fabits-basket-popup-list'>
      {Object.entries(basketDetails).map(([basketKey, basketItems]) => {
        const failedCount = basketItems.filter((item) => item.status === 'FAILED').length
        const firstItem = basketItems[0]
        const isAlert = tone !== 'success'

        return (
          <div
            key={basketKey}
            className={`fabits-basket-popup-card ${
              isAlert ? 'fabits-basket-popup-card-alert' : ''
            }`}
          >
            <div
              className={`fabits-basket-popup-card-head ${
                expandedBaskets[basketKey] ? 'is-expanded' : ''
              }`}
            >
              <img
                src={`${env.SVGS}/basket.svg`}
                alt=''
                aria-hidden='true'
                className='fabits-basket-popup-card-icon'
              />

              <div>
                {firstItem?.customerBasketName && (
                  <p className='fabits-basket-popup-card-title'>{firstItem.customerBasketName}</p>
                )}
                {firstItem?.status && (
                  <p className='fabits-basket-popup-card-status'>
                    {tone === 'partial'
                      ? `(${failedCount}/${basketItems.length}) Unsuccessful`
                      : firstItem.status}
                  </p>
                )}
              </div>
            </div>

            {expandedBaskets[basketKey] && (
              <div className='fabits-basket-popup-fund-list'>
                {basketItems.map((fund, index) => {
                  const fundAlert = fund.status !== 'SUCCESS'

                  return (
                    <div
                      key={fund.id || index}
                      className={`fabits-basket-popup-fund ${
                        fundAlert ? 'fabits-basket-popup-fund-alert' : ''
                      }`}
                    >
                      <img
                        src={`${env.SVGS}/basket.svg`}
                        alt=''
                        aria-hidden='true'
                        className='fabits-basket-popup-card-icon'
                      />
                      <div>
                        <p className='fabits-basket-popup-fund-title'>
                          {fund?.schemeName ? fund.schemeName : fund?.legalName}
                        </p>
                        <p className='fabits-basket-popup-card-status'>{fund?.status}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            )}

            <button
              type='button'
              className='fabits-basket-popup-show-more'
              onClick={() => toggleBasketExpansion(basketKey)}
            >
              {expandedBaskets[basketKey] ? 'Show less' : 'Show more'}
            </button>
          </div>
        )
      })}
    </div>
  )
}

const SuccessPopup = ({ isModalOpen, onClose, goBack, data }) => {
  const navigate = useNavigate()

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity='success'
      title={data?.title || 'Order successful'}
      message={data?.message}
      contentClassName={ACTION_PLAN_POPUP_CLASS}
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
            onClick={() => {
              onClose(), navigate(goBack)
            }}
          >
            Close
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
            onClick={() => {
              onClose(), navigate(data?.redirectTo)
            }}
          >
            Order History
          </button>
        </>
      }
    />
  )
}

const FailedPopup = ({ isModalOpen, onClose, baskets }) => {
  const [expandedBaskets, setExpandedBaskets] = useState({})

  const toggleBasketExpansion = (basketKey) => {
    setExpandedBaskets((prev) => ({
      ...prev,
      [basketKey]: !prev[basketKey],
    }))
  }

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity='error'
      title='Basket Order Failed'
      bodyClassName='fabits-basket-popup-body'
      contentClassName={ACTION_PLAN_POPUP_CLASS}
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
          >
            Retry
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
          >
            Get Help
          </button>
        </>
      }
    >
      {baskets ? (
        <ActionPlanRows
          basketDetails={baskets}
          expandedBaskets={expandedBaskets}
          toggleBasketExpansion={toggleBasketExpansion}
          tone='error'
        />
      ) : (
        <ActionPlanLoadingState />
      )}
    </FullPagePopupLayout>
  )
}

const PartialPopup = ({ isModalOpen, onClose, baskets }) => {
  const [expandedBaskets, setExpandedBaskets] = useState({})

  const toggleBasketExpansion = (basketKey) => {
    setExpandedBaskets((prev) => ({
      ...prev,
      [basketKey]: !prev[basketKey],
    }))
  }

  const statusCount =
    baskets &&
    Object.values(baskets)
      .flat()
      .reduce(
        (acc, item) => {
          if (item.status === 'SUCCESS') {
            acc.success += 1
          } else if (item.status === 'FAILED') {
            acc.failed += 1
          }
          return acc
        },
        { success: 0, failed: 0 },
      )

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity='partial'
      title={`Partial Order Successful (${statusCount?.failed}/${
        statusCount?.failed + statusCount?.success
      })`}
      bodyClassName='fabits-basket-popup-body'
      contentClassName={ACTION_PLAN_POPUP_CLASS}
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
            onClick={onClose}
          >
            Close
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
          >
            Get Help
          </button>
        </>
      }
    >
      {baskets ? (
        <ActionPlanRows
          basketDetails={baskets}
          expandedBaskets={expandedBaskets}
          toggleBasketExpansion={toggleBasketExpansion}
          tone='partial'
        />
      ) : (
        <ActionPlanLoadingState />
      )}
    </FullPagePopupLayout>
  )
}

const SipSuccess = ({ isModalOpen, onClose, data }) => {
  const navigate = useNavigate()

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity={data?.severity}
      title={data?.title || 'SIP registered'}
      message={data?.message}
      contentClassName={ACTION_PLAN_POPUP_CLASS}
      actionsClassName='fabits-global-popup-actions-single'
      actions={
        <button
          type='button'
          className='fabits-global-popup-button fabits-global-popup-button-primary'
          onClick={() => {
            onClose(), navigate(data?.redirectTo)
          }}
        >
          Continue
        </button>
      }
    />
  )
}

const InfoPopup = ({ isModalOpen, onClose, goBack, data }) => {
  const navigate = useNavigate()

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity={data?.severity}
      title={data?.title || 'Order update'}
      message={data?.message}
      contentClassName={ACTION_PLAN_POPUP_CLASS}
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
            onClick={() => {
              onClose(), navigate(goBack)
            }}
          >
            Close
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
            onClick={() => {
              onClose(), navigate(data?.redirectTo)
            }}
          >
            Continue
          </button>
        </>
      }
    />
  )
}

const ActionPlanPopup = () => {
  const { isOpen, onClose, type, data } = useModal()
  const { goBack } = data
  const isModalOpen = isOpen && type === 'openActionPlanPopup'

  return (
    <>
      {data?.severity === 'sipsuccess' && (
        <SipSuccess isModalOpen={isModalOpen} onClose={onClose} data={data} />
      )}

      {data?.severity === 'success' && (
        <SuccessPopup isModalOpen={isModalOpen} onClose={onClose} goBack={goBack} data={data} />
      )}

      {data?.severity === 'info' && (
        <InfoPopup isModalOpen={isModalOpen} onClose={onClose} goBack={goBack} data={data} />
      )}

      {data?.severity === 'error' && (
        <FailedPopup isModalOpen={isModalOpen} onClose={onClose} baskets={data?.baskets} />
      )}

      {data?.severity !== 'sipsuccess' &&
        data?.severity !== 'success' &&
        data?.severity !== 'error' &&
        data?.severity !== 'info' && (
          <PartialPopup isModalOpen={isModalOpen} onClose={onClose} baskets={data?.baskets} />
        )}
    </>
  )
}

export default ActionPlanPopup
